import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Government()
{
    const router = useRouter();
    return (
        <>
            <section className="hero-reseller government-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Government & Associations</h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold  mb-4 publicPageNewTextColor">
                                Empower your community. Govern with confidence.
                            </h2>
                            <p className="text-muted mb-3">
                                In government and associations, progress is built on <b>stakeholder alignment</b> and community trust.
                                But traditional consultations and formal reports can’t keep pace with the speed of public debate.
                                Instant Polls gives <b>public sector leaders</b> and association executives the power to capture <b>real-time sentiment</b>,
                                validate member needs, and turn live discussions into defensible decisions.
                            </p>
                            <p className="text-muted mb-3">
                                Whether you’re facilitating a <b> town hall</b>, a <b>legislative briefing</b>, or a member summit, our platform turns <b>community feedback</b> into actionable direction.
                                By displaying results instantly, you foster the transparency that strengthens <b> public engagement</b> and ensures every voice is counted while the moment still matters.
                            </p>
                            <p className="text-muted mb-3">
                                Because better consultation leads to better policy — and better outcomes for the people you serve.
                            </p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <Image src="/industry/government-public-sector-polling.png" alt="government public sector polling platform" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Challenge</h5>
                                    <p className="card-text text-muted">
                                        For government agencies and industry associations, progress depends on <b>stakeholder alignment</b> and public trust.
                                        Yet, traditional consultation—lengthy surveys and town hall Q&As—often feels slow, one-sided, and disconnected from the community’s immediate concerns.
                                        By the time feedback is processed, the momentum for <b> policy development</b> or member engagement has often stalled.
                                    </p>
                                    <p className="card-text text-muted">
                                        Leaders need a more transparent, responsive way to capture <b>public sentiment</b>, validate member needs, and build consensus in the moment.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Solution</h5>
                                    <p className="card-text text-muted">
                                        Instant Polls empowers public sector and association leaders to turn passive audiences into an engaged <b> governance network</b>. Whether you are facilitating a <b> legislative briefing</b>,
                                        a <b>council meeting</b>, or an <b>industry summit</b>, our platform allows you to launch branded, secure polls in seconds.
                                    </p>
                                    <p className="card-text text-muted">
                                        By displaying results instantly, you foster a culture of transparency and <b>inclusive decision-making</b>. It is the fast, secure, and professional way to ensure every voice is heard—giving you the <b>real-time data</b> needed to guide policy and strategy with confidence.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Result</h5>
                                    <p className="card-text text-muted">
                                        From local councils to national peak bodies, Instant Polls helps turn <b> community feedback</b> into immediate direction.
                                        It improves <b>transparency</b>, accelerates <b>consensus building</b>, and ensures that leadership remains deeply connected to the people they serve.
                                    </p>
                                    <p className="card-text text-muted">
                                        The result is a <b> governing experience</b> that feels more democratic, efficient, and responsive—one that transforms complex debate into a clear path forward.
                                        Because when <b>stakeholder insight </b> moves at the speed of the conversation, every meeting delivers a stronger mandate.
                                    </p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>
                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section-gvt d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h2 className="fw-bold mb-3 publicPageNewTextColor" >Collective voice<br />Clear direction.</h2>
                            <p className="text-muted mb-3 text-dark">
                                From local councils and government departments to national industry bodies, Instant Polls helps turn<b> community feedback </b>into immediate direction.
                                It improves <b> public transparency</b>, accelerates <b>consensus building</b>, and ensures that leadership remains deeply connected to the stakeholders they represent.</p>
                            <p className="text-muted mb-3 text-dark">
                                The result is a <b> governance experience</b> that feels more democratic, responsive, and efficient — one that transforms complex public debate into a clear, unified path forward.
                                Because when <b> stakeholder insight</b> moves at the speed of the conversation, every session delivers a stronger mandate.
                            </p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2" >BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Government.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;